'use strict';

var classCallCheck = require('../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var withStyles = require('../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Typography = require('../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    borderBottom: '1px solid lightGrey',
    lineHeight: '0.1em',
    margin: '10px 0 20px'
  },
  span: {
    background: '#fff',
    padding: '0 10px'
  }
};
var Divider = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(Divider, _PureComponent);

  function Divider() {
    classCallCheck(this, Divider);

    return possibleConstructorReturn(this, getPrototypeOf(Divider).apply(this, arguments));
  }

  createClass(Divider, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React__default["default"].createElement(Typography["default"], {
        className: classes.container
      }, React__default["default"].createElement("span", {
        className: classes.span
      }, this.props.children));
    }
  }]);

  return Divider;
}(React.PureComponent)) || _class);

module.exports = Divider;
